import { render } from "./ProductInfo.vue?vue&type=template&id=67cbba0c&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=67cbba0c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cbba0c"],['__file',"resources/js/modules/labelinsight-products/components/ProductInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67cbba0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67cbba0c', __exports__)) {
    api.reload('67cbba0c', __exports__)
  }
  
  module.hot.accept("./ProductInfo.vue?vue&type=template&id=67cbba0c&scoped=true", () => {
    api.rerender('67cbba0c', render)
  })

}


export default __exports__